import React from "react";
import Button, { ButtonVariant } from "@/components/Button";
import { FormValidationTooltip } from "./FormValidationTooltip";

interface MissingField {
  label: string;
  path: string;
}

interface ActionButtonProps {
  onClick: () => void;
  disabled: boolean;
  isLoading: boolean;
  variant?: ButtonVariant;
  children: React.ReactNode;
  missingFields?: MissingField[];
  showTooltip?: boolean;
  tooltipTitle?: string;
  [key: string]: any; // For additional props like 'key'
}

export function ActionButton({
  onClick,
  disabled,
  isLoading,
  variant = "filled",
  children,
  missingFields = [],
  showTooltip = false,
  tooltipTitle = "Required Fields",
  ...props
}: ActionButtonProps) {
  const button = (
    <Button {...props} loading={isLoading} disabled={disabled} variant={variant} onClick={onClick}>
      {children}
    </Button>
  );

  return (
    <FormValidationTooltip missingFields={missingFields} showTooltip={showTooltip} title={tooltipTitle}>
      {button}
    </FormValidationTooltip>
  );
}
